<template>
  <div class="w-full h-full p-4">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="Customer/Segment Data and Charts" name="segments">
        <Segments />
      </el-tab-pane>
      <el-tab-pane label="Customer/Recency Charts" name="recency">
        <Recency />
      </el-tab-pane>
      <el-tab-pane label="Customer/Monetary Charts" name="monetary">
        <Monetary />
      </el-tab-pane>
      <el-tab-pane label="Customer/Frequency Charts" name="frequency">
        <Frequency />
      </el-tab-pane>
      <el-tab-pane v-if="false" label="Customer/Gender Charts" name="gender"></el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Segments from './includes/CustomerCharts/Segments.vue';
import Recency from './includes/CustomerCharts/Recency.vue';
import Frequency from './includes/CustomerCharts/Frequency.vue';
import Monetary from './includes/CustomerCharts/Monetary.vue';

export default {
  name: 'CustomerCharts',
  components: {
    Recency,
    Segments,
    Frequency,
    Monetary,
  },
  computed: {
    segmentData() {
      return this.$store.getters['AICustomers/getCustomerSegmentData'] || [];
    },

    recencyData() {
      return this.$store.getters['AICustomers/getRFMData']('recency_scores', 'Recency') || [];
    },

    frequencyData() {
      return this.$store.getters['AICustomers/getRFMData']('frequency_scores', 'Frequency') || [];
    },

    monetaryData() {
      return this.$store.getters['AICustomers/getRFMData']('monetary_scores', 'Monetary') || [];
    },
  },
  data() {
    return {
      loading: false,
      activeName: 'segments',
      segmentDataChartOptions: {
        title: 'Customers In Segments',
        height: '500',
        bar: { groupWidth: '95%' },
        legend: { position: 'none' },
        // axes: {
        //   x: {
        //     0: {
        //       side: 'top',
        //       label: 'Percentage'
        //     } // Top x-axis.
        //   }
        // }
      },
    };
  },
  methods: {
    handleClick() {},
  },
};
</script>

<style scoped lang="scss">
.charts {
  flex: 0 1 100%;
}
</style>
